import moment from 'moment';
import { dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';

export const getActivityList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        actID: item.actId,
        actDateCompleted: item.actDateCompleted
          ? moment(item.actDateCompleted).format(dateFormat).split('T')[0]
          : '-',
        actDateEarly: item.actDateEarly
          ? moment(item.actDateEarly).format(dateFormat).split('T')[0]
          : '-',
        actDateLate: item.actDateLate
          ? moment(item.actDateLate).format(dateFormat).split('T')[0]
          : '-',
        activityType: item.activityType?.value,
        activityBy: item.activityBy?.value,
        activityWith: item.activityWith?.value,
        key: item.episode.partcipant.key,
        CDC: item.episode.CDC,
        episodeID: item.episode.episodeID,
        billToOrganization: item.billToOrganization?.value,
        RgnId: item.episode.RgnId,
        actIavId: item.actIavId,
      })),
    };
  }).catch((e) => alert(e));
};
